import { render, staticRenderFns } from "./FileXmarkButton.vue?vue&type=template&id=f310f72c&"
import script from "./FileXmarkButton.vue?vue&type=script&lang=ts&"
export * from "./FileXmarkButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports